import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback, Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';

class AccountPasswordFields extends Component {
  constructor(props) {
    super(props)
    this.state = {
        popoverOpen1: false
    }
    this.toggle = this.toggle.bind(this);
  }

  toggle(i) {
      if (i === 1) {
          this.setState({
              popoverOpen1: !this.state.popoverOpen1
          });
      }
  }

  render() {
    return (
      <div>      
        <FormGroup>
          <Label for="accountPassword">Verification Password</Label>
          <Input type="text" value={this.props.accountPassword} onChange={this.props.handleChange} onBlur={this.props.validateField} name="accountPassword" id="accountPassword" invalid={this.props.validation.accountPassword.isInvalid} autoFocus={this.props.autoFocus} maxLength="15" autoComplete="accountPassword" autoCapitalize="off" autoCorrect="off" />
          <FormFeedback>{this.props.validation.accountPassword.message}</FormFeedback>
        </FormGroup>
        {/* PBI 441350 VOA: Remove the tooltip button for Verification Password and display the help text below the input field */}
        <p><em>Verification Password is a verbal password that you'll need to give to verify your identity over the phone. (Max. 15 characters, can be letters and/or numbers)</em></p>            
      </div>);
  }
}
AccountPasswordFields.defaultProps= {
  handleChange:() => {},
  validation: {
    accountPassword: {
      isInvalid: false,
      message: ""
    }
  },
  autoFocus: false

};

AccountPasswordFields.propTypes = {
  handleChange: PropTypes.func,
  autoFocus: PropTypes.bool
};

export default AccountPasswordFields;


// WEBPACK FOOTER //
// ./src/components/Fields/AccountPasswordFields.js